module.exports = __webpack_public_path__ + "img/8.2821bd00.png";